import { networkRequest } from "./core";

const API_URL = process.env.REACT_APP_API_BASE_URL;

const getAllTeams = () => {
  return networkRequest
    .get(`${API_URL}/teams/getAllTeam`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });
};

const addTeam = (title, members) => {
  return networkRequest
    .post(`${API_URL}/teams/addTeam`, {
      team_title: title,
      participant_ids: members,
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });
};

const updateTeam = (id, title, members, created_by) => {
  return networkRequest
    .put(`${API_URL}/teams/updateTeam?id=${id}`, {
      team_title: title,
      participant_ids: members,
      created_by: created_by,
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
      return Promise.reject(err);
    });
};

const deleteTeam = (id) => {
  return networkRequest
    .delete(`${API_URL}/teams/deleteTeam?id=${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });
};

export const TeamService = {
  getAllTeams,
  addTeam,
  updateTeam,
  deleteTeam,
};
